import { render, staticRenderFns } from "./HubDashboard.vue?vue&type=template&id=5f2456a5&scoped=true"
import script from "./HubDashboard.vue?vue&type=script&lang=js"
export * from "./HubDashboard.vue?vue&type=script&lang=js"
import style0 from "./HubDashboard.vue?vue&type=style&index=0&id=5f2456a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2456a5",
  null
  
)

export default component.exports